<template>
    <section class="top-wrapper">
        <span class="span1">{{ $t('Home.Top.span1') }}</span>
        <span class="span2">{{$t('Home.Top.span2')}}</span>
        <article class="top-left">
            <div class="left-shape1"></div>
            <div class="left-shape2"></div>
        </article>
        <div class="top-right"></div>
    </section>
</template>

<script>
export default {
    name: 'home-top'
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.top-wrapper {
    width: 100vw;
    height: 700px;
    background-color: #10424b;
    display: flex;
    flex-direction: row;
    color: white;
    .span1 {
        font-size: 80px;
        width: 700px;
        top: 200px;
        left: 100px;
        z-index: 2;
        font-weight: 700;
        text-shadow: 2px 2px black;
        position: absolute;
        text-align: left;
        @include mobile {
            font-size: 50px;
            max-width: 80vw;
            left: 50px;
            top: 150px;
        }
    }
    .span2 {
        width: 700px;
        font-size: 24px;
        z-index: 2;
        position: absolute;
        left: 100px;
        top: 600px;
        text-align: left;
        
        @include mobile {
            top: 500px;
            left: 50px;
            max-width: 80vw;
            text-shadow: 1px 1px black;
        }
    }
    .top-left {
        width: 40%;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .left-shape1 {
            position: absolute;
            width: 150px;
            height: 700px;
            background-color: #14525e;
            margin: 0 0 0 20%;
            transform: skew(20deg);
            @include mobile {
                width: 80px;
                margin: 0 0 0 30%;
            }
        }
        .left-shape2 {
            margin: 0 20% 0 0;
            position: absolute;
            width: 150px;
            height: 700px;
            background-color: #14525e;
            transform: skew(20deg);
            @include mobile {
                width: 80px;
            }
        }
    }
    .top-right {
        background-size: cover;
        background-position: center;
        background-image: url('../../../public/img/1.jpg');
        opacity: 0.75;
        width: 60%;
        height: 100%;
    }
}
</style>